// src/components/GuestRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const GuestRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // while we’re checking “are we logged in or not?” show something
  if (loading) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Loading…</div>;
  }

  // if we _are_ logged in, immediately redirect to /angebot
  if (user) {
    return <Navigate to="/" replace />;
  }

  // otherwise render the login form (or whatever children you passed)
  return children;
};

export default GuestRoute;
